import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ImagesConfig } from '@qaroni-core/config/app/images.config';
import { EvaluationEmployeeNineGrid } from '@qaroni-shared/types/evaluation-employee-nine-grid';

@Component({
  selector: 'qaroni-matrix-nine-grid-box-employee',
  templateUrl: './matrix-nine-grid-box-employee.component.html',
  styleUrl: './matrix-nine-grid-box-employee.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MatrixNineGridBoxEmployeeComponent {
  readonly employee = input<EvaluationEmployeeNineGrid | null>(null);
  public isOpen = false;

  get employeeImage() {
    return this.employee()?.employeeImage ?? ImagesConfig.maleAvatar.url;
  }
}
